import ModalCardMobile, {
  ModalCardProps as VKModalCardProps,
} from '@vkontakte/vkui/dist/components/ModalCard/ModalCard';
import { getPlatformComponent } from '../utils/getPlatformComponent';

export type ModalCardProps = VKModalCardProps;

export default getPlatformComponent<ModalCardProps>({ mobile: ModalCardMobile as any, desktop: ModalCardMobile as any });
